import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageNumber: 1,
  rowsPerPage: 5,
};

const richiestePaginationSlice = createSlice({
  name: "richiestePagination",
  initialState,
  reducers: {
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setPagination: (state, action) => {
      state.pageNumber = action.payload.pageNumber || state.pageNumber;
      state.rowsPerPage = action.payload.rowsPerPage || state.rowsPerPage;
    },
    resetPagination: (state) => {
      state.pageNumber = 1;
      state.rowsPerPage = 5;
    },
  },
});

export const { setPageNumber, setRowsPerPage, setPagination, resetPagination } =
  richiestePaginationSlice.actions;
export default richiestePaginationSlice.reducer;
